import styled from 'styled-components';
import { color } from 'styles/pallete';

// Definindo as tipagens para as propriedades do containerCheck
interface ContainerCheckProps {
	widthCheck?: string; // Largura do checkbox
	isError?: boolean; // Indica se há erro
	borderColor?: string; // Cor da borda
	ballRadius?: boolean; // Define se é arredondado
	widthSvgCheck?: number; // Largura do SVG
}

interface BoxProps {
	fontSize?: number; // Tamanho da fonte
}

export const Container = styled.div`
	display: flex;
	align-items: center;
`;

export const containerCheck = styled.div.withConfig({
	shouldForwardProp: (prop) =>
		![
			'widthCheck',
			'isError',
			'borderColor',
			'ballRadius',
			'widthSvgCheck'
		].includes(prop)
})<ContainerCheckProps>`
	position: relative;
	width: ${(props) => props.widthCheck || '20px'};
	height: ${(props) => props.widthCheck || '20px'};
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	cursor: pointer;

	input {
		display: none;
	}

	label {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: ${(props) => props.widthCheck || '20px'};
		height: ${(props) => props.widthCheck || '20px'};
		border: ${({ isError, borderColor }) =>
			isError
				? `1px solid ${color.interface.red}`
				: `1px solid ${borderColor || color.interface.lightGray}`};
		border-radius: ${(props) => (props.ballRadius ? '50%' : '15%')};
	}

	img {
		position: absolute;
		width: ${(props) => `${props.widthSvgCheck || 15}px`};
	}
`;

export const Box = styled.div<BoxProps>`
	display: flex;
	margin-left: 0.5rem;

	.error-send {
		font-family:
			'nunito-bold',
			-apple-system,
			BlinkMacSystemFont,
			'Segoe UI',
			Roboto,
			Oxygen,
			Ubuntu,
			Cantarell,
			'Open Sans',
			'Helvetica Neue',
			sans-serif;
		font-size: 10px;
		color: ${color.interface.red};
		padding-left: 5px;
		height: 10px;
	}

	> span {
		color: ${color.interface.lightGray};
		font-size: ${(props) => `${props.fontSize || 1.2}rem`};
	}
`;
